import React from "react";
import propTypes from "prop-types";

import NavDropdown from "react-bootstrap/cjs/NavDropdown";

import "./ScrollableNavDropdown.css";

const ScrollableNavDropdown = (props) => {
  const { children, ...forwardProps } = props;

  return (
    <NavDropdown {...forwardProps} bsPrefix={"nav-link scrollable-dropdown"}>
      {children}
    </NavDropdown>
  );
};

ScrollableNavDropdown.propTypes = {
  id: propTypes.string.isRequired,
  title: propTypes.string.isRequired,
};

export default ScrollableNavDropdown;
